function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var GroupsApiService = /*#__PURE__*/function () {
  function GroupsApiService() {
    _classCallCheck(this, GroupsApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(GroupsApiService, [{
    key: "GetMyGroups",
    value: function GetMyGroups() {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/MyGroups");
      return Ajax.Get(url);
    }
  }, {
    key: "SearchGroups",
    value: function SearchGroups(formData) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/SearchGroups");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "SuggestGroup",
    value: function SuggestGroup(formData) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/SuggestGroup");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetGroupDetails",
    value: function GetGroupDetails(id, showFullAddress, countGroupInquiries) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/GetGroupDetails/").concat(id, "?showFullAddress=").concat(showFullAddress, "&countGroupInquiries=").concat(countGroupInquiries);
      return Ajax.Get(url).then(function (response) {
        return response;
      })["catch"]( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error) {
          var _errorJson$message;

          var errorJson;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return error.json();

                case 2:
                  errorJson = _context.sent;
                  throw new Error((_errorJson$message = errorJson.message) !== null && _errorJson$message !== void 0 ? _errorJson$message : "Failed to load group data.");

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "SignUp",
    value: function SignUp(formData) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/SignUp");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "Inquire",
    value: function Inquire(formData) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/Inquire");
      return Ajax.Post(url, formData);
    }
  }, {
    key: "GetConfigurations",
    value: function GetConfigurations() {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/GetConfigurations");
      return Ajax.Get(url);
    }
  }, {
    key: "HasInquired",
    value: function HasInquired(groupId, contactId) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/HasInquired?groupId=").concat(groupId).concat(!!contactId ? "&contactId=".concat(contactId) : '');
      return Ajax.Get(url);
    }
  }, {
    key: "HasSignedUp",
    value: function HasSignedUp(groupId, contactId) {
      var url = "".concat(this._appRoot, "/Api/GroupsApi/HasSignedUp?groupId=").concat(groupId).concat(!!contactId ? "&contactId=".concat(contactId) : '');
      return Ajax.Get(url);
    }
  }]);

  return GroupsApiService;
}();